import React from "react";
import { Link } from "react-router-dom";
import SEO from '../../components/SEO';


export default function SearchEngineMarketing() {
  return (
      <>
    <SEO title="Search Engine Marketing" />
    <div className="w-full">
      {/* Hero Section */}
      <div className="bg-[#8cc540] py-16 text-white text-center px-4">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          Search Engine Marketing (SEM)
        </h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto">
          Maximize reach and conversions with ROI-driven Pay-Per-Click (PPC)
          campaigns on Google, Bing, and more.
        </p>
      </div>

      {/* Content Section */}
      <div className="max-w-[1200px] mx-auto px-4 py-12 space-y-12">
        {/* What is SEM */}
        <section>
          <h2 className="text-3xl font-bold text-[#0a3c6d] text-center mb-6">
            What is SEM?
          </h2>
          <p className="text-gray-700 leading-relaxed text-lg text-center max-w-4xl mx-auto">
            Search Engine Marketing is the practice of using paid advertisements
            that appear on search engine results pages (or SERPs). Advertisers
            bid on keywords that users might enter when looking for certain
            products or services, giving your business instant visibility and
            measurable conversions.
          </p>
        </section>

        {/* SEM Services */}
        <section>
          <h2 className="text-3xl font-bold text-[#0a3c6d] text-center mb-10">
            Our SEM Services Include
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {[
              "Google Ads Setup & Management",
              "Keyword Research & Strategy",
              "Display Ads & Retargeting",
              "Bing Ads Campaigns",
              "Conversion Tracking & Analytics",
              "A/B Testing of Ad Creatives",
            ].map((item, idx) => (
              <div
                key={idx}
                className="border-t-4 border-[#8cc540] bg-white shadow p-6 rounded hover:shadow-md transition"
              >
                <h4 className="text-lg text-[#0a3c6d] font-semibold">
                  {item}
                </h4>
              </div>
            ))}
          </div>
        </section>

        {/* Why Choose Us */}
        <section>
          <h2 className="text-3xl font-bold text-[#0a3c6d] text-center mb-6">
            Why Choose Our SEM Experts?
          </h2>
          <p className="text-gray-700 text-lg text-center max-w-4xl mx-auto">
            We focus on delivering performance-driven results by leveraging
            targeted ad placements, optimizing cost-per-click, and ensuring
            ongoing monitoring and strategy adjustments. Our approach is
            transparent, data-backed, and built to scale with your growth.
          </p>
        </section>

        {/* Quote Block */}
        <section className="bg-[#f7fdf3] border-l-4 border-[#8cc540] p-6 rounded-md shadow-sm text-center max-w-3xl mx-auto">
          <p className="text-[#0a3c6d] font-medium text-xl italic">
            “The best place to hide a dead body is the second page of Google.”
          </p>
          <p className="text-sm text-gray-500 mt-2">– Anonymous</p>
        </section>

        {/* CTA */}
        <div className="text-center pt-10">
          <Link
            to="/contact-us"
            className="inline-block bg-[#8cc540] hover:bg-[#79a436] text-white font-semibold text-lg px-8 py-4 rounded-md shadow transition"
          >
            Start Your SEM Campaign Today
          </Link>
        </div>
      </div>
    </div>
    </>
  );
}
